import { Frequency, type PlanConfig } from "core";

export type PlanGroup = {
  planSlug: string;
  variants: PlanConfig[];
};

export function groupPlansBySlug(plans: PlanConfig[]): PlanGroup[] {
  const bySlug = plans.reduce<Record<string, PlanConfig[]>>(
    (acc, plan) => ({
      ...acc,
      [plan.planSlug]: [...(acc[plan.planSlug] ?? []), plan],
    }),
    {},
  );

  return Object.values(bySlug)
    .map((variants) => ({
      planSlug: variants[0].planSlug,
      variants: [...variants].sort((a) =>
        a.interval === Frequency.Month ? -1 : 1,
      ),
    }))
    .sort(
      (a, b) =>
        (a.variants[0].baseUnitAmount ?? 0) -
        (b.variants[0].baseUnitAmount ?? 0),
    );
}
